import { Card } from '@diwata/ironvale'

export function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <div>
      <div className="dw-page-header">
        <div className="dw-page-title">{title}</div>
      </div>
      <Card>
        <p className="dw-empty">{note}</p>
      </Card>
    </div>
  )
}
